import Api from '@/api';
import { Utilities } from '@spectorasoftware/homegauge-shared';
import { Http } from '@/utilities/util';

const { LogRocketUtility } = Utilities;

const addLogRocketIdentity = user => {
  if (!user) {
    return;
  }

  const { legacyId, primaryEmail, username } = user;
  try {
    LogRocketUtility.addUser(legacyId, { email: primaryEmail, name: username });
  } catch (err) {
    // eat the error
  }
};

const loadIsEligibleForOffers = (context, user) => new Promise((resolve, reject) => {
  Api.customerService.getCompanies(user.legacyId)
    .then(companiesResponse => Api.companyService
      .getExtraCares(companiesResponse.data.body.companyIds))
    .then(extraCaresResponse => {
      const isEligibleForOffers
        = extraCaresResponse.data.body.some(element => element.EXTRA_CARE);
      context.commit('setIsEligibleForOffers', isEligibleForOffers);
      resolve(isEligibleForOffers);
    })
    .catch(error => {
      context.commit('setIsEligibleForOffers', false);
      const httpError = Http.createError(
        error,
        'user.actions.loadIsEligibleForOffers',
        { user },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const loadMe = context => new Promise((resolve, reject) => {
  Api.personService.getMyPerson()
    .then(response => {
      context.commit('setUser', response.data);

      let userJwt = Api.authService.getAuthToken();
      if (userJwt) {
        userJwt = userJwt.replace('Bearer ', '');
      }
      context.commit('setUserJwt', userJwt);

      addLogRocketIdentity(response.data);
      resolve(response.data);
    })
    .catch(error => {
      // This is the first API call. If the global
      // error is set like other api call errors,
      // the error route is activated and the app
      // ends up in a loop.
      reject(error);
    });
});

const patchPerson = (context, personData) => new Promise(async (resolve, reject) => {
  context.commit('setSaveLoading', true);
  context.commit('setSaveError', null);

  context.commit('setUser', { ...context.state.currentUser, ...personData });
  Api.personService.patchPerson(personData)
    .then(res => {
      context.commit('setUser', res.data);
      context.commit('setSaveLoading', false);
      resolve();
    })
    .catch(err => {
      context.commit('setSaveError', err);
      context.commit('setSaveLoading', false);
      reject();
    });
});

const logout = () => {
  Api.authService.destroyAuthToken();
  Api.authService.logoutClassic();
};

const saveMyCustomer = (context, customerData) => new Promise((resolve, reject) => {
  context.commit('setSaveLoading', true);
  context.commit('setSaveError', null);

  const payload = {
    ...customerData,
    address1: customerData.primaryAddress.address1,
    address2: customerData.primaryAddress.address2,
    city: customerData.primaryAddress.city,
    postalCode: customerData.primaryAddress.postalCode,
    state: customerData.primaryAddress.state,
  };

  Api.personService.postCustomer(payload.legacyId, payload)
    .then(response => {
      context.commit('setUser', response.data);
      context.commit('setSaveLoading', false);
      resolve();
    })
    .catch(error => {
      context.commit('setSaveError', error);
      context.commit('setSaveLoading', false);
      reject();
    });
});

const getAccountLastModified = (context, personId) => new Promise((resolve, reject) => {
  Api.personService.getAccountLastModified(personId)
    .then(response => {
      context.commit('getAccountLastModified', response.data.body);
      resolve(response);
    })
    .catch(() => {
      context.commit('getAccountLastModified', {});
      reject();
    });
});

export default {
  loadIsEligibleForOffers,
  loadMe,
  patchPerson,
  logout,
  saveMyCustomer,
  getAccountLastModified,
};
